import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import attendanceService from "./attendanceService";

export const getAttendance = createAsyncThunk(
  "attendance/get-attendance",
  async (id, thunkAPI) => {
    try {
      return await attendanceService.getAttendance(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getWeeklyAttendance = createAsyncThunk(
  "attendance/get-weeklyattendance",
  async (id, thunkAPI) => {
    try {
      return await attendanceService.getAWeeklyttendance(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getSchoolVisits = createAsyncThunk(
  "attendance/get-schoolVisits",
  async (params, thunkAPI) => {
    try {
      return await attendanceService.getSchoolVisits(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getSchoolVisitCount = createAsyncThunk(
  "attendance/get-SchoolVisitCount",
  async (params, thunkAPI) => {
    try {
      return await attendanceService.getSchoolVisitCount(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch schools"
      );
    }
  }
);
export const postAssignSchool = createAsyncThunk(
  "attendance/post-assignschool", // Updated to match service name
  async (data, thunkAPI) => {
    try {
      return await attendanceService.postAssignSchool(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  attendances: [],
  attendancesall: [],
  schoolVisits: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAttendance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSchoolVisitCount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAttendance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.attendancesall = action.payload;
      })
      .addCase(getAttendance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getWeeklyAttendance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getWeeklyAttendance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.attendances = action.payload;
      })
      .addCase(getWeeklyAttendance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getSchoolVisits.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postAssignSchool.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postAssignSchool.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.message =
          action.payload.message || "Schools assigned successfully";
      })
      .addCase(postAssignSchool.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload?.message || "Failed to assign schools";
      })

      .addCase(getSchoolVisits.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.schoolVisits = action.payload;
      })
      .addCase(getSchoolVisits.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default attendanceSlice.reducer;

// //
// import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
// import attendanceService from "./attendanceService";

// export const getAttendance = createAsyncThunk(
//   "attendance/get-attendance",
//   async (id, thunkAPI) => {
//     try {
//       return await attendanceService.getAttendance(id);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

// export const getWeeklyAttendance = createAsyncThunk(
//   "attendance/get-weeklyattendance",
//   async (id, thunkAPI) => {
//     try {
//       return await attendanceService.getAWeeklyttendance(id);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

// // export const getSchoolVisits = createAsyncThunk(
// //   "attendance/get-schoolVisits",
// //   async (params, thunkAPI) => {
// //     try {
// //       return await attendanceService.getSchoolVisits(params);
// //     } catch (error) {
// //       return thunkAPI.rejectWithValue(error);
// //     }
// //   }
// // );
// export const getSchoolVisits = createAsyncThunk(
//   "attendance/get-schoolVisits",
//   async (params, thunkAPI) => {
//     try {
//       return await attendanceService.getSchoolVisits(params);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(
//         error.message || "Failed to fetch schools"
//       );
//     }
//   }
// );

// export const getSchoolVisitCount = createAsyncThunk(
//   "attendance/get-SchoolVisitCount",
//   async (params, thunkAPI) => {
//     try {
//       return await attendanceService.getSchoolVisitCount(params);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(
//         error.message || "Failed to fetch schools"
//       );
//     }
//   }
// );

// export const postAssignSchool = createAsyncThunk(
//   "attendance/post-assignschool", // Updated to match service name
//   async (data, thunkAPI) => {
//     try {
//       return await attendanceService.postAssignSchool(data);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

// export const resetState = createAction("Reset_all");

// const initialState = {
//   attendances: [],
//   attendancesall: [],
//   schoolVisits: [],
//   isError: false,
//   isLoading: false,
//   isSuccess: false,
//   message: "",
// };

// export const attendanceSlice = createSlice({
//   name: "attendance",
//   initialState,
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(getAttendance.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getAttendance.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.attendancesall = action.payload;
//       })
//       .addCase(getAttendance.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.isSuccess = false;
//         state.message = action.error;
//       })
//       .addCase(getWeeklyAttendance.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getWeeklyAttendance.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.attendances = action.payload;
//       })
//       .addCase(getWeeklyAttendance.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.isSuccess = false;
//         state.message = action.error;
//       })
//       .addCase(getSchoolVisits.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getSchoolVisitCount.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(getSchoolVisits.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.schoolVisits = action.payload;
//       })
//       .addCase(getSchoolVisits.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.isSuccess = false;
//         state.message = action.error;
//       })
//       .addCase(getSchoolVisitCount.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.schoolVisits = action.payload;
//       })
//       .addCase(getSchoolVisitCount.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.isSuccess = false;
//         state.message = action.error;
//       })
//       .addCase(postAssignSchool.pending, (state) => {
//         state.isLoading = true;
//       })
//       .addCase(postAssignSchool.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.message =
//           action.payload.message || "Schools assigned successfully";
//       })
//       .addCase(postAssignSchool.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.isSuccess = false;
//         state.message = action.payload?.message || "Failed to assign schools";
//       })
//       .addCase(resetState, () => initialState);
//   },
// });

// export default attendanceSlice.reducer;
